import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GridUser } from '../../models/grid-user';
import { UserReviewRequest } from '../../../review/user-review/models/user-review-request';
import { User } from '../../models/user';

@Injectable({
    providedIn: 'root',
})
export class UserManagementService {
    constructor(private readonly http: HttpClient) {}

    getAll(): Promise<GridUser[]> {
        return lastValueFrom(this.http.get<GridUser[]>('api/users'));
    }

    get(id: number): Promise<GridUser> {
        return lastValueFrom(this.http.get<GridUser>(`api/users/${id}`));
    }

    review(id: number, request: UserReviewRequest): Promise<User> {
        return lastValueFrom(
            this.http.patch<User>(`api/users/${id}/review`, request),
        );
    }
}
